import AskCommiteeDecisionView from 'components/CommiteeDecision/AskCommiteeDecisionView';

const AskOpinion = () => {
  return <AskCommiteeDecisionView />;
};

export default AskOpinion;
